<template>
  <v-container fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card elevation="8" class="text-center pa-8">
          <v-avatar color="blue darken-2" size="80" class="mb-4">
            <v-icon size="50" color="white">mdi-microsoft</v-icon>
          </v-avatar>
          
          <h2 class="text-h4 font-weight-bold mb-2">Microsoft Conectado!</h2>
          <p class="text-body-1 grey--text mb-6">
            Sua integração com o Azure DevOps / Microsoft foi configurada com sucesso.
          </p>

          <v-btn
            color="blue darken-2"
            large
            rounded
            dark
            @click="fecharJanela"
          >
            <v-icon left>mdi-check</v-icon>
            Fechar
          </v-btn>

          <p class="text-caption grey--text mt-4">
            Esta janela fechará automaticamente em {{ countdown }}s
          </p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'MicrosoftSuccess',

  data: () => ({
    countdown: 5,
    intervalId: null,
  }),

  mounted() {
    console.log('✅ Microsoft OAuth Success - Integração concluída')
    
    // Countdown para fechar automaticamente
    this.intervalId = setInterval(() => {
      this.countdown--
      if (this.countdown === 0) {
        this.fecharJanela()
      }
    }, 1000)
  },

  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },

  methods: {
    fecharJanela() {
      // Tentar fechar a janela popup
      if (window.opener) {
        console.log('🔄 Fechando popup OAuth Microsoft...')
        window.close()
      } else {
        // Se não for popup, redirecionar para settings
        console.log('↩️ Redirecionando para configurações...')
        this.$router.push('/admin-settings')
      }
    },
  },
}
</script>

<style scoped>
.fill-height {
  min-height: 100vh;
  background: linear-gradient(135deg, #1565C0 0%, #0D47A1 100%);
}
</style>
